import React, { Component } from 'react';
import { CtrlCollection, CtrlType } from '@yuigoto/ctrl';
import { ShippingAddress } from 'core/types/ShippingAddress';
import { GlamboxEndpoints } from 'core/glambox/GlamboxEndpoints';
import { ExecuteRequest } from 'core/glambox/GlamboxApi';
import { ControlRenderer } from 'components/renderers/ControlRenderer';
import { connect } from 'react-redux';
import { UiActions } from 'state/actions/UiActions';

/**
 * @type {CtrlProps[]}
 */
const PersonAddressControls = [
  {
    name: 'shippingPostalCode',
    label: 'CEP',
    type: CtrlType.CEP,
    required: true,
    requiredMessage: 'Este campo é obrigatório',
  },
  {
    name: 'shippingState',
    label: 'UF',
    type: CtrlType.HIDDEN,
    required: true,
    requiredMessage: 'Este campo é obrigatório',
  },
  {
    name: 'shippingStateId',
    label: 'Estado',
    type: CtrlType.DROPDOWN,
    options: [],
    required: true,
    requiredMessage: 'Este campo é obrigatório',
  },
  {
    name: 'shippingCity',
    label: 'Cidade',
    type: CtrlType.HIDDEN,
    required: true,
    requiredMessage: 'Este campo é obrigatório',
  },
  {
    name: 'shippingCityId',
    label: 'Cidade',
    type: CtrlType.DROPDOWN,
    options: [],
    required: true,
  },
  {
    name: 'shippingStreetNeighborhood',
    label: 'Bairro',
    type: CtrlType.DEFAULT,
    required: true,
    requiredMessage: 'Este campo é obrigatório',
  },
  {
    name: 'shippingStreet',
    label: 'Endereço',
    type: CtrlType.DEFAULT,
    required: true,
    requiredMessage: 'Este campo é obrigatório',
  },
  {
    name: 'shippingStreetNumber',
    label: 'Nº',
    type: CtrlType.DEFAULT,
    required: true,
    requiredMessage: 'Este campo é obrigatório',
  },
  {
    name: 'shippingStreetExtension',
    label: 'Complemento',
    type: CtrlType.DEFAULT,
    required: false,
    requiredMessage: 'Este campo é obrigatório',
  },
  {
    name: 'shippingName',
    label: 'Nome',
    type: CtrlType.DEFAULT,
    required: true,
    requiredMessage: 'Este campo é obrigatório',
  },
  {
    name: 'shippingPhone',
    label: 'Número',
    type: CtrlType.DEFAULT,
    required: true,
    requiredMessage: 'Este campo é obrigatório',
  },
];

class PersonAddress extends Component {
  address = null;
  controls = null;
  erro = 'CEP não encontrado';

  constructor(props) {
    super(props);
    this.state = {
      states: {},
      cities: {},
      shippingStateId: this.props.person.stateCode,
      shippingCityId: this.props.person.cityCode,
    };

    this.bootstrapControls();
  }

  componentDidMount() {
    this._loadStateData();
  }

  bootstrapControls = () => {
    this.address = new ShippingAddress();
    this.controls = new CtrlCollection();

    for (let n = 0; n < PersonAddressControls.length; n++) {
      switch (PersonAddressControls[n].name) {
        case 'shippingPostalCode':
          PersonAddressControls[n].onChange = (e, value) => {
            this._requestCepShipping(value);
          };
          break;
        case 'shippingStateId':
          PersonAddressControls[n].onChange = (e, value) => {
            this._updateStateCitiesShipping(value);
          };
          break;
        case 'shippingCityId':
        case 'cityCode':
          PersonAddressControls[n].onChange = (e, value) => {
            this._updateCityShipping(value);
          };
          break;
        default:
          break;
      }

      this.controls.add(PersonAddressControls[n]);
    }

    const { person } = this.props;

    this.controls.setValue('shippingPostalCode', person.postalCode);
    this.controls.setValue('shippingStateId', person.stateCode);
    this.controls.setValue('shippingState', person.state);
    this.controls.setValue('shippingCity', person.city);
    this.controls.setValue('shippingCityId', person.cityCode);
    this.controls.setValue('shippingStreetNeighborhood', person.neighborhood);
    this.controls.setValue('shippingStreet', person.street);
    this.controls.setValue('shippingStreetNumber', person.streetNumber);
    this.controls.setValue('shippingStreetExtension', person.streetExtensions);

    const { subscriberId } = this.props;

    if (subscriberId) {
      this.controls.setValue('shippingName', subscriberId.shippingName);
      this.controls.setValue('shippingPhone', subscriberId.shippingPhone);
    }

    if (person.stateCode) {
      this._updateStateCitiesShipping(person.stateCode);
    }
  };

  _stateToOptions = stateData => {
    let states = [];

    for (let n = 0; n < stateData.length; n++) {
      states.push({
        name: stateData[n].nome,
        value: stateData[n].codigoIbge || stateData[n].codigoCep,
      });
    }

    states.sort((a, b) => {
      return a.name > b.name;
    });

    return states;
  };

  _requestCepShipping = cep => {
    let cln = cep.replace(/[^\d]+/gi, '');
    if (cln.length < 8 || cln.length > 8) return false;

    ExecuteRequest(GlamboxEndpoints.Open.locationFromCep, null, 'GET', null, {
      cep,
    }).then(response => {
      const { result, statusCode } = response;

      if (statusCode === 200) {
        this.controls.setValue('shippingState', result.estado);
        this.controls.setValue('shippingStateId', result.codigoIbgeEstado);
        this.controls.setValue('shippingCity', result.cidade);
        this.controls.setValue('shippingCityId', result.codigoCepCidade);
        this.controls.setValue('shippingStreetNeighborhood', result.bairro);
        this.controls.setValue('shippingStreet', result.logradouro);

        this._updateStateCitiesShipping(result.codigoIbgeEstado);
        this.setState({
          shippingCityId: result.codigoCepCidade,
        });
      } else {
        this.controls.setValue('shippingState', null);
        this.controls.setValue('shippingStateId', 0);
        this.controls.setValue('shippingCity', null);
        this.controls.setValue('shippingCityId', 0);

        this.controls.setValue('shippingStreetNeighborhood', null);
        this.controls.setValue('shippingStreet', null);

        this.controls.get('shippingCityId').disabled = true;
      }

      this.forceUpdate();
    });
  };

  _loadStateData = async () => {
    let response = await ExecuteRequest(
      GlamboxEndpoints.Open.listStates,
      null,
      'GET'
    );

    const { result, statusCode } = response;
    if (statusCode === 200) {
      this.setState(
        {
          states: result,
        },
        () => {
          const shippingStateId = this.controls.get('shippingStateId'),
            states = this._stateToOptions(result);

          shippingStateId.options = states;
          this.forceUpdate();
        }
      );
    }
  };

  _citiesToOptions = (stateId, citiesData) => {
    let cities = [];

    if (typeof citiesData[stateId] !== 'undefined') {
      let citiesList = citiesData[stateId];

      for (let n = 0; n < citiesList.length; n++) {
        cities.push({
          name: citiesList[n].nome,
          //value: citiesList[n].codigoIbge
          value: citiesList[n].codigoCepCidade,
        });
      }
    }

    cities.sort((a, b) => {
      return a.name > b.name;
    });

    return cities;
  };

  _requestStateCities = async (stateId, callback) => {
    if (typeof this.state.cities[stateId] !== 'undefined') {
      callback(stateId);
    } else {
      let response = await ExecuteRequest(
        GlamboxEndpoints.Open.listStateCities,
        {
          stateId: stateId,
        },
        'GET',
        null
      );

      const { result, statusCode } = response;
      if (statusCode === 200) {
        this.setState(
          {
            cities: { [stateId]: result.result },
          },
          () => {
            callback(stateId);
          }
        );
      }
    }
  };

  _updateStateCitiesShipping = async stateId => {
    while (Object.keys(this.state.states).length === 0) {
      await this._loadStateData();
    }

    if (this.controls.get('shippingCityId').disabled) {
      this.controls.get('shippingCityId').disabled = false;
    }

    stateId = parseInt(stateId);
    this._requestStateCities(stateId, id => {
      const shippingCityId = this.controls.get('shippingCityId'),
        shippingCity = this.controls.get('shippingCity'),
        shippingState = this.controls.get('shippingState'),
        cities = this._citiesToOptions(id, this.state.cities);

      let stateName;
      for (let state of this.state.states) {
        if (state.codigoIbge === id) {
          stateName = state.nome;
        }
      }

      shippingState.value = stateName;

      shippingCityId.options = cities;

      for (let city of this.state.cities[id]) {
        if (
          parseInt(shippingCityId.value) === city.codigoCepCidade ||
          parseInt(shippingCityId.value) === city.codigoIbge
        ) {
          const _rgx = new RegExp(`^${shippingCity.value?.trim()}`, 'g');

          if (_rgx.test(city.nome)) {
            this.controls.setValue('shippingCityId', city.codigoCepCidade);
            this.controls.setValue('shippingCity', city.nome);
          }
        }
      }

      this.controls.setValue('shippingStateId', stateId);

      this.setState({
        shippingStateId: stateId,
      });

      this.forceUpdate();
    });
  };

  _updateCityShipping = cityId => {
    cityId = parseInt(cityId);
    const shippingCity = this.controls.get('shippingCity'),
      shippingStateId = this.controls.get('shippingStateId'),
      stateId = shippingStateId.value,
      cities = this.state.cities[stateId];
    let cityName;

    for (let city of cities) {
      if (city.codigoCepCidade === cityId || city.codigoIbge === cityId) {
        cityName = city.nome;
      }
    }

    shippingCity.value = cityName;
    this.controls.setValue('shippingCityId', cityId);

    this.setState({
      shippingCityId: cityId,
    });

    this.forceUpdate();
  };

  /**
   * @param {Event} e
   */

  _formEvent = e => {
    e.preventDefault();

    let isValid = this.controls.validate();
    if (isValid) {
      let body = this.props.subscriberId
        ? Object.assign({}, this.controls.toObject(), {
            shippingStateId: this.state.shippingStateId,
            shippingCityId: this.state.shippingCityId,
            subscriberId: this.props.subscriberId.id,
          })
        : Object.assign({}, this.controls.toObject(), {
            shippingStateId: this.state.shippingStateId,
            shippingCityId: this.state.shippingCityId,
          });

      ExecuteRequest(
        GlamboxEndpoints.Subscriber.addressChange,
        body,
        'PUT',
        {
          Authorization: this.props.token.Authorization,
        },
        null,
        response => {
          const { result, statusCode } = response;

          if (statusCode === 200) {
            this.props.successAlert(
              result && result.message
                ? result.message
                : 'Dados de endereço atualizados com sucesso.'
            );
          } else {
            this.props.errorAlert(
              result && result.message
                ? this.erro
                : 'Não foi possível atualizar os dados de endereço. Por favor, tente novamente.'
            );
          }
        }
      );
    } else {
      this.props.errorAlert('Verifique o preenchimento dos campos');
    }
  };

  render() {
    return (
      <>
        <div className={'level-2'}>
          <div className={'gb-contentblock p-3 p-lg-4'}>
            <form id={'voucher-shipping-form'} onSubmit={this._formEvent}>
              <p>
                <small>* Campo Obrigatório</small>
              </p>

              {ControlRenderer.renderCollection(this.controls)}

              <button
                type={'submit'}
                className={'btn btn-light-pink mt-2 mb-2'}
              >
                <strong>Atualizar</strong>
              </button>
            </form>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    token: state.token.data,
    person: state.person.data.person,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    successAlert: message => {
      dispatch(UiActions.publishSuccessAlert(message));
    },
    errorAlert: message => {
      dispatch(UiActions.publishErrorAlert(message));
    },
  };
};

PersonAddress = connect(mapStateToProps, mapDispatchToProps)(PersonAddress);

export { PersonAddress };
